// Terminal identity for the Terminal Register.
//
// The Electron main process owns a stable `device_id` per installation; the
// renderer caches it and stamps it on every request so the backend can keep a
// live list of signed-in tills (branch, user, app version, last contact) and
// revoke one lost register without signing the whole pharmacy out.
//
// Plain browsers have no identity here and send no headers.

let identity = null;
let hydrated = false;
let hydration = null;

export const initDesktopDevice = async () => {
  if (hydration) return hydration;
  if (hydrated) return identity;
  hydration = hydrateDevice();
  try { return await hydration; } finally { hydration = null; }
};

const hydrateDevice = async () => {
  if (typeof window === 'undefined' || !window.pharmxai?.getDeviceIdentity) return null;
  try {
    identity = await window.pharmxai.getDeviceIdentity();
  } catch {
    identity = null;
  }
  hydrated = true;
  return identity;
};

export const getDeviceIdentity = () => identity;

export const getDeviceHeaders = () => {
  if (!identity?.device_id) return {};
  return {
    'X-Device-Id': identity.device_id,
    'X-Device-Label': identity.label || '',
    'X-Device-Platform': identity.platform || '',
    'X-App-Version': identity.app_version || '',
  };
};
